import * as React from "react";

function SvgFreeTimePlanting(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 578 592"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit={2}
      {...props}
    >
      <g transform="translate(-127.827 -82.543)">
        <g
          id="free_time_planting_svg__planting"
          transform="matrix(1.50338 0 0 1.41818 -194.645 -260.587)"
        >
          <path
            d="M387.157 650.113c-7.39-27.151-13.887-50.138-12.389-100.705 5.939-24.298 44.338-51.553 44.434-53.907.098-2.427-25.725 9.402-43.849 33.692 3.637-33.346 11.341-84.947 26.506-121.487 19.103-46.028 45.584-73.473 68.609-84.497-26.701-.122-83.234 59.622-101.404 154.641-4.327-19.781-31.394-54.486-31.758-53.221-.59 2.049 26.072 49.719 26.159 69.127-5.14 54.195-5.773 102.667 6.835 155.725 2.772 11.668 20.355 13.488 16.857.632z"
            fill="#fe8d8a"
          />
          <clipPath id="free_time_planting_svg___clip1">
            <path d="M387.157 650.113c-7.39-27.151-13.887-50.138-12.389-100.705 5.939-24.298 44.338-51.553 44.434-53.907.098-2.427-25.725 9.402-43.849 33.692 3.637-33.346 11.341-84.947 26.506-121.487 19.103-46.028 45.584-73.473 68.609-84.497-26.701-.122-83.234 59.622-101.404 154.641-4.327-19.781-31.394-54.486-31.758-53.221-.59 2.049 26.072 49.719 26.159 69.127-5.14 54.195-5.773 102.667 6.835 155.725 2.772 11.668 20.355 13.488 16.857.632z" />
          </clipPath>
          <g clipPath="url(#free_time_planting_svg___clip1)">
            <path
              d="M375.352 689.663c-25.018-81.804-25.906-181.813-12.44-257.417 17.535-98.447 62.031-176.104 112.358-215.714-179.738-62.792-254.633 357.318-99.918 473.131z"
              fill="#fd9794"
              transform="matrix(.66517 0 0 .70513 129.471 183.747)"
            />
          </g>
          <g transform="matrix(.55567 -.39158 .37763 .53573 -4.135 258.792)">
            <path
              d="M202.698 280.697s-24.375 111.812-24.375 173.125c0 47.947 38.928 86.875 86.875 86.875 47.948 0 87.754-38.936 86.875-86.875-2.5-136.313-149.375-173.125-149.375-173.125z"
              fill="#feb4b2"
            />
            <clipPath id="free_time_planting_svg___clip2">
              <path d="M202.698 280.697s-24.375 111.812-24.375 173.125c0 47.947 38.928 86.875 86.875 86.875 47.948 0 87.754-38.936 86.875-86.875-2.5-136.313-149.375-173.125-149.375-173.125z" />
            </clipPath>
            <g clipPath="url(#free_time_planting_svg___clip2)">
              <path
                d="M86.185 210.163c48.974-54.988 88.5 94.773 132 119 49.244 27.425 86.241 5.549 101.041-24.454 17.927-36.343-6.041-107.546-6.041-107.546 82.764 72.248 90.573 168.085 24 243-178.657-28.786-235.148-121.146-251-230z"
                fill="#fea9a6"
                transform="matrix(.79978 .58458 -.59763 .87938 224.249 23.828)"
              />
            </g>
          </g>
          <g transform="matrix(-.47446 -.57812 -.52065 .4273 815.807 459.846)">
            <path
              d="M159.296 271.823s45.489 123.126 38.856 171.293c-7.161 52.005 19.099 97.581 67.046 97.581 47.948 0 78.263-39.707 86.875-86.875 28.123-154.028-192.777-181.999-192.777-181.999z"
              fill="#feb4b2"
            />
            <clipPath id="free_time_planting_svg___clip3">
              <path d="M159.296 271.823s45.489 123.126 38.856 171.293c-7.161 52.005 19.099 97.581 67.046 97.581 47.948 0 78.263-39.707 86.875-86.875 28.123-154.028-192.777-181.999-192.777-181.999z" />
            </clipPath>
            <g clipPath="url(#free_time_planting_svg___clip3)">
              <path
                d="M417.185 373.163c-25.955 52.216 46.44 109.184 90 93 62.897-23.369 190.765-60.824 223-31-74.992 77.58-163.178 139.61-313 129-48.418-88.501-58.248-145.166 0-191z"
                fill="#fea9a6"
                transform="matrix(-.56424 -.76339 -.7288 .66416 867.562 527.627)"
              />
            </g>
          </g>
          <g transform="matrix(-.40134 -.51043 -.4772 .3752 801.895 281.663)">
            <path
              d="M273.787 273.851s-65.068 108.87-75.635 169.265c-9.036 51.644 19.099 97.581 67.046 97.581 47.948 0 85.179-38.85 86.875-86.875 3.868-109.516-78.286-179.971-78.286-179.971z"
              fill="#feb4b2"
            />
            <clipPath id="free_time_planting_svg___clip4">
              <path d="M273.787 273.851s-65.068 108.87-75.635 169.265c-9.036 51.644 19.099 97.581 67.046 97.581 47.948 0 85.179-38.85 86.875-86.875 3.868-109.516-78.286-179.971-78.286-179.971z" />
            </clipPath>
            <g clipPath="url(#free_time_planting_svg___clip4)">
              <path
                d="M450.352 136.663c-6.687 68.01 38.867 91.733 83.333 78 34.994-10.808 73.436-67.092 126-142.667-4.653 91.653-45.569 160.347-116 214.667-163.657-16.822-133.787-75.885-93.333-150z"
                fill="#fea9a6"
                transform="matrix(-.63318 -.86137 -.85367 .71797 758.633 771.073)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgFreeTimePlanting;
